import React from "react";
import {
    Paper,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    TablePagination,
    Select,
    MenuItem
} from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import RemoveButton from "@material-ui/icons/Remove";
import _ from "lodash";
import { noImg } from "vrcore-dashboard/dist/utilities";
export class QualsSelectedTableData extends React.Component {
    render() {
        const {
            TablePaginationHelper,
            selectedQualifications,
            classes,
            setQualSelectedTablePage,
            setQualSelectedTableRow,
            qualCategories
        } = this.props;
        return (
            <Paper className={classes.table} style={{ border: "1px solid green" }}>
                <div>
                    <Typography variant="title">Qualifications Required</Typography>
                    <Select
                        style={{ width: "18%", marginTop: "10px" }}
                        value={this.props.selectedCategory}
                        onChange={event => {
                            this.props.setCategory(event.target.value);
                        }}
                    >
                        <MenuItem key={0} value={"all_categories"}>
                            All Categories
                        </MenuItem>
                        {Object.keys(qualCategories).map(e => {
                            return (
                                <MenuItem value={qualCategories[e]} key={e}>
                                    {qualCategories[e]}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </div>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TablePagination
                                colSpan={12}
                                ActionsComponent={TablePaginationHelper}
                                count={
                                    selectedQualifications.length === undefined
                                        ? 0
                                        : selectedQualifications.length
                                }
                                rowsPerPage={this.props.rowsPerPageQualsTable2}
                                page={this.props.pageQualsTable2}
                                onChangePage={(event, page) => {
                                    setQualSelectedTablePage(page);
                                }}
                                onChangeRowsPerPage={event => {
                                    setQualSelectedTableRow(event.target.value);
                                }}
                                rowsPerPageOptions={[50, 100]}
                            />
                        </TableRow>
                        <TableRow className={classes.tableCell}>
                            <TableCell>
                                <Typography variant="body2">
                                    <b> Title</b>
                                </Typography>
                            </TableCell>

                            <TableCell className={classes.tableCell}>
                                <Typography variant="body2">
                                    <b>Category</b>
                                </Typography>
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                <Typography variant="body2">
                                    <b>Image Required</b>
                                </Typography>
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                <Typography variant="body2">
                                    <b>Registration No. Required</b>
                                </Typography>
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                <Typography variant="body2">
                                    <b>Verification Required</b>
                                </Typography>
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                <Typography variant="body2">
                                    <b>Expiry Date Required</b>
                                </Typography>
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                <Typography variant="body2">
                                    <b>Action </b>
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    {selectedQualifications && (
                        <TableBody>
                            {selectedQualifications.map(e => {
                                let qualCategory = _.get(e, "qualification_category") || null;
                                let qualTitle = _.get(e, "qualification_title") || null;
                                let qualID = _.get(e, "qualification_id") || null;
                                let qualRegReq =
                                    _.get(e, "qualification_reg_number_required") || false;
                                let qualExpReq =
                                    _.get(e, "qualification_expiry_date_required") || false;
                                let qualImgReq = _.get(e, "qualification_image_required") || false;
                                let qualVerReq =
                                    _.get(e, "qualification_verification_required") || false;
                                return (
                                    <TableRow key={qualID}>
                                        <TableCell
                                            className={classes.tableCell}
                                            style={{ width: "200px" }}
                                        >
                                            <div style={{ display: "flex" }}>
                                                <Typography
                                                    variant="body2"
                                                    style={{ width: "140px" }}
                                                >
                                                    <b>{qualTitle}</b>
                                                </Typography>
                                                <img
                                                    style={{
                                                        height: "50px",
                                                        width: "50px",
                                                        marginLeft: "10px"
                                                    }}
                                                    src={
                                                        e.qualification_valid_img !== ""
                                                            ? e.qualification_valid_img
                                                            : noImg
                                                    }
                                                    alt="Qualification Logo"
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            <Typography variant="body2">{qualCategory}</Typography>
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                backgroundColor:
                                                    qualImgReq === true ? "green" : "red"
                                            }}
                                            className={classes.tableCell}
                                        >
                                            <Typography variant="body2">
                                                {qualImgReq === true ? "Yes" : "No"}
                                            </Typography>
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                backgroundColor:
                                                    qualRegReq === true ? "green" : "red"
                                            }}
                                            className={classes.tableCell}
                                        >
                                            <Typography variant="body2">
                                                {qualRegReq === true ? "Yes" : "No"}
                                            </Typography>
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                backgroundColor:
                                                    qualVerReq === true ? "green" : "red"
                                            }}
                                            className={classes.tableCell}
                                        >
                                            <Typography variant="body2">
                                                {qualVerReq === true ? "Yes" : "No"}
                                            </Typography>
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                backgroundColor:
                                                    qualExpReq === true ? "green" : "red"
                                            }}
                                            className={classes.tableCell}
                                        >
                                            <Typography variant="body2">
                                                {qualExpReq === true ? "Yes" : "No"}
                                            </Typography>
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            <IconButton
                                                style={{
                                                    color: "red",
                                                    border: "1px solid red"
                                                }}
                                                onClick={() => {
                                                    this.props.setDeleteModalInfo(
                                                        qualID,
                                                        qualTitle,
                                                        true
                                                    );
                                                }}
                                            >
                                                <RemoveButton />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    )}
                </Table>
            </Paper>
        );
    }
}
